<div *ngIf="!showErrorDiv" >
  <ul ngbNav #nav="ngbNav" class="testdata-nav nav-tabs" style="border-bottom: 1px solid #a8a8a8;" [(activeId)]="activeTabId" (navChange)="changeTab($event)">
    <li title="Targets" [ngbNavItem]="0">
      <a ngbNavLink><i class="fas fa-chart-line mr-2"></i>Execution Trend</a>
      <ng-template ngbNavContent>
          <div id="plot-line-scatter1"></div>
      </ng-template>
    </li>
    <li title="Actions" [ngbNavItem]="1">
      <a ngbNavLink><i class="fas fa-poll mr-2"></i>End-to-End Time</a>
      <ng-template ngbNavContent>
          <div id="plot-bar"></div>
      </ng-template>
    </li>
    <li title="Targets" [ngbNavItem]="2">
      <a ngbNavLink><i class="fas fa-chart-bar"></i>Precise Time</a>
      <ng-template ngbNavContent>
          <div id="plot-line-scatter"></div>
      </ng-template>
    </li>

  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
<div *ngIf="showErrorDiv" class="error-msg">{{errorMessage}}</div>

